module.exports = __webpack_public_path__ + "static/media/1029973.9520cfab.png";